import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mapDistinct' })
export class MapDistinctPipe implements PipeTransform {
  transform(value: any[], prop: string): any[] {
    const distinctList = Array.from(new Set(value.map((item: any) => item[prop])));
    return distinctList;
  }
}
